import http from './http';

export async function lookupPostalCode(cp) {
  const res = await http.get(`/geo/cp/${cp}`);
  return res.data?.data ?? res.data;
}

export async function lookupPostalCodeById(id) {
  try {
    const res = await http.get(`/geo/postal_code_id/${id}`);
    return res.data?.data ?? res.data;
  } catch {
    return null;
  }
}

export async function lookupPostalCodeAddress(cp) {
  const res = await http.get(`/address/postal-code/${cp}`);
  return res.data?.data ?? res.data;
}